/**
 * @file_purpose  page for showing login form of visitor manager login
 * @author Swarnali Ghosh
 * @Date_Created 04-08-2023
 * @Date_Modified 04-08-2023
 */
import React, { useState, useEffect } from 'react'
import { withRouter, useHistory, } from 'react-router-dom'
import {
  CForm,
  CInput,
  CInputGroup,
  CLabel,
  CSelect
} from '@coreui/react'
import { ToastContainer, toast } from 'react-toastify';
import Constants from 'src/Utility/Constants';
import VisitorManagementService from 'src/apis/VisitorManagementService';
import HiddenEye from "src/assets/icons/hidden_eye.png";
import Eye from "src/assets/icons/eye.png";
import LoginImage from "src/assets/icons/log_img.png"
import blueOverlay from "src/assets/icons/blue_overlay.png"
import Visit from "src/assets/icons/visit_apple.png"

const VisitorManagerLogin = (props) => {
  const history = useHistory();
  //Define states
  const [state, setState] = useState({
    username: "",
    password: ""
  })
  const [loadingData, setLoadingData] = useState(true);
  const [userNameErrors, setUserNameErrors] = useState();
  const [passwordErrors, setPasswordErrors] = useState();
  const [passwordShown, setPasswordShown] = useState(false);
  const [selectedLocationId,setSelectedLocationId] = useState();
  const [locationErrors,setLocationErrors] = useState();
  const [location, setLocation] = useState();

  const togglePasswordVisibility = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const handleChange = (e) => {
    const { id, value } = e.target
    setState(prevState => ({
      ...prevState,
      [id]: value
    }))
  }

  useEffect(() => {
    if (localStorage.getItem("visitor_manager_auth_token")) {
        history.push("/visitor")
        window.location.reload();
    }


        /**
     * @author Swarnali Ghosh
     * @Date_Created 31-10-2023
     * @Date_Modified 31-10-2023
     * @function async
     * @functionName loadLocations
     * @functionPurpose this function gets the list of locations.
     *
     * @functionParam {}
     *
     * @functionSuccess Success status and message.
     *
     * @functionError {Boolean} error is there.
     * @functionError {String} message  Description message.
     */

        async function loadLocations() {
          VisitorManagementService.visitorManagerLoginLocations()
            .then((res) => {
             
              if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                const data = res.data;
                var arrLocations = [];
                data.map((item, index) =>
                arrLocations.push({
                    location_id: item.location_id,
                    location_name: item.location_name,
                  })
                );
                setLocation(arrLocations);
                setLoadingData(false);
              } else {
                toast.error(res.message, {
                  position: toast.POSITION.BOTTOM_RIGHT,
                });
              }
            })
            .catch((error) => {
              console.log(error)
            });
        }

        if (loadingData) {
          // if the result is not ready so you make the axios call
          loadLocations()
      }

}, [loadingData]);

const handleLocationChange = (e) => {
  const { value } = e.target;
  setSelectedLocationId(value);
};

  // const handleMenuSet = (e, menuName) => {
  //   setMenuName(menuName)
  //   props.onChangeMenu(menuName);
  // }

  /* Validation Checking */
  const ValidateForm = (e) => {
    e.preventDefault();
    if (handleValidation()) {
      VisitorManagerLoginSubmitClick();
    }
    else {
      toast.error("Please fill all the fields !", {
        position: toast.POSITION.BOTTOM_RIGHT
      });
    }
  }

  /* Validate all fields */
  const handleValidation = (e) => {
    let usernameErrors, passwordErrors, locationErrors;
    let formIsValid = true;

    // username
    if (!state.username) {
      formIsValid = false;
      usernameErrors = "Username cannot be empty";
      setUserNameErrors(usernameErrors);
    } else {
      setUserNameErrors('');
    }

    // password

    if (!state.password) {
      formIsValid = false;
      passwordErrors = "Password can not be empty";
      setPasswordErrors(passwordErrors);
    } else {
      setPasswordErrors('');
    }

    if (!selectedLocationId) {
      formIsValid = false;
      locationErrors = "Location can not be empty";
      setLocationErrors(locationErrors);
    } else {
      setLocationErrors("");
    }

    return formIsValid;
  }


  /**
  * @author Swarnali Ghosh
  * @Date_Created 04-08-2023
  * @Date_Modified 04-08-2023
  * @function sync
  * @functionName VisitorManagerLoginSubmitClick
  * @functionPurpose this function submit visitor manager login form data.
  *
  * @functionParam {payload object:username,password}
  * 
  * @functionSuccess Success status and message.
  *
  * @functionError {Boolean} error error is there.
  * @functionError {String} message  Description message.
  */


  const VisitorManagerLoginSubmitClick = (e) => {
    let params = JSON.stringify({
      username: state.username,
      password: state.password,
      location_id: parseInt(selectedLocationId)
    })
    VisitorManagementService.visitorManagerlogin(params).then(res => {
      if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
        localStorage.setItem("visitor_manager_auth_token", res.data.token);

        toast.success(res.message, {
          position: toast.POSITION.BOTTOM_RIGHT
        });

        history.push("/visitor");

      }
      else {
        toast.error(res.message, {
          position: toast.POSITION.BOTTOM_RIGHT
        });
      }
    }).catch(error => {
      console.log(error);
    })
  }


  return (
    <div className="signin_sec">
       <div className="overlay_sec">
        <img src={blueOverlay} alt='' />
      </div>
      <div className="container-fluid">
        <div className="row" style={{marginTop:'90px'}}>
          <div className="col-sm-12">
            <div className="logo">
              {/* <img src={Logo} alt='' /> */}
            </div>
          </div>
        </div>
      </div>
      <div className="container">
      <div className="row">
      <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-4 col-sm-12">
          <div className="login_left_sec">
          <h2><span>Welcome to</span> <br/>Red Apple Visitor <br/>Management System </h2>
          <img src={LoginImage} alt='' />
          </div>
      </div>
      <div className="col-xxl-2 col-xl-2 col-lg-1 col-md-1 col-sm-12"></div>
      <div className="col-xxl-5 col-xl-5 col-lg-6 col-md-7 col-sm-12">
        <div className="login_sec">
          <ToastContainer />

          <div>
            <CForm className="commentForm" onSubmit={ValidateForm}>
             <div className="visit_inn">
             <span className="visit_apple"> <img src={Visit} alt='' /></span>
              <h6>Welcome to <strong>Red Apple Visitor Management System</strong></h6>
             </div>

              <div class="login_inner">
                <CLabel htmlFor="text-input">Username <span style={{ color: "red" }}>  * </span></CLabel>
                <CInput type="text" placeholder="Username" id="username" autoComplete="username"
                  value={state.username}
                  onChange={handleChange}
                />
                <span style={{ color: "red" }}>{userNameErrors}</span>
              </div>

              <div class="login_inner">
                <CLabel htmlFor="text-input">Password <span style={{ color: "red" }}>  * </span></CLabel>
                <CInputGroup>
                  <CInput placeholder="Password" id="password" autoComplete="current-password" value={state.password}
                    onChange={handleChange}
                    type={passwordShown ? "text" : "password"}
                  />

                  {/* <i onClick={togglePasswordVisibility} className={passwordShown ? 'fa fa-eye' : 'fa fa-eye-slash'} style={{ cursor: 'pointer' }}></i> */}
                  <img className="hidden_eye" alt='eye-icon' onClick={togglePasswordVisibility} src={passwordShown ? Eye : HiddenEye} style={{ cursor: 'pointer' }}></img>
                  {/* <CInputGroupAppend>
                        <CInputGroupText>
                          <i onClick={togglePasswordVisibility} className={passwordShown ? 'fa fa-eye' : 'fa fa-eye-slash'} style={{ cursor: 'pointer' }}></i>
                        </CInputGroupText>
                      </CInputGroupAppend> */}
                     
                </CInputGroup>
                 <span style={{ color: "red" }}>{passwordErrors}</span>
              </div>

              <div class="login_inner">
                <CLabel htmlFor="text-input">Location  <span style={{ color: "red" }}>  * </span></CLabel>
                <CInputGroup>
                <CSelect
                        custom
                        name="location"
                        id="location"
                        value={selectedLocationId}
                        onChange={handleLocationChange}
                      >
                        <option value="">Select Location</option>
                        {location && location.length > 0 &&
                          location.map((item, index) => (
                            <option
                              key={item.location_id}
                              value={item.location_id}
                            >
                              {item.location_name}
                            </option>
                          ))}
                      </CSelect>
                </CInputGroup>
                 <span style={{ color: "red" }}>{locationErrors}</span>
              </div>


            


              <button type="submit" className="login_btn">Login</button>

            </CForm>
          </div>


        </div>
      </div>
    </div>
      </div>
    </div>
    


  )
}

export default VisitorManagerLogin
